<template>
  <div class="p-loading">
    <el-loading size="48" />
  </div>
</template>

<script>
export default {
  name: 'Loading'
};
</script>

<style lang="scss" scoped>
.p-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
